import { motion } from "framer-motion";
import { SectionHeading } from "./SectionHeading";
const items = [{
  e: "😰",
  t: "Apruebas planificaciones sin estar completamente seguro de que son la mejor opción para el paciente."
}, {
  e: "⏳",
  t: "Pierdes demasiado tiempo revisando casos porque no tienes un método claro para tomar decisiones."
}, {
  e: "🤔",
  t: "No sabes con certeza cuándo realizar IPR, expansión, distalización o modificar attachments."
}, {
  e: "📉",
  t: "Algunos tratamientos requieren refinamientos que podrían haberse evitado desde la planificación inicial."
}, {
  e: "😓",
  t: "Dependes demasiado del software o del técnico porque no tienes un protocolo propio para validar cada caso."
}, {
  e: "😩",
  t: "Te gustaría ofrecer tratamientos con mayor seguridad, pero aún sientes incertidumbre en casos complejos."
}];
export function Identify() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-149" data-mp="3pr0kotg2g7jg">
      <div className="mx-auto max-w-lg px-5 sm:max-w-3xl lg:max-w-5xl" data-id="element-150" data-mp="1rr95ab7pnhmv">
        <SectionHeading eyebrow="¿Te identificas?" title="¿Te identificas con alguna de estas situaciones?" subtitle="Si respondes “Sí” a una sola, este sistema fue diseñado para ti." data-id="element-151" data-mp="1rtc33hf3uf25" />

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-152" data-mp="1np4dzj4qix3e">
          {items.map((it, i) => <motion.div key={it.t} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i % 3 * 0.08
        }} className="rounded-2xl border border-slate-100 bg-slate-50 p-5 transition-colors hover:border-[#1e88e5]/30 hover:bg-white hover:shadow-md" data-id="element-153" data-mp="2begkgb8ogr20" data-mpi={i}>
              <span className="text-3xl" data-id="element-154" data-mp="2ud2j7jgq262r">{it.e}</span>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-[15px]" data-id="element-155" data-mp="2z4klqbye8epu">
                {it.t}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}